import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddGuideMutationVariables = Types.Exact<{
  input: Types.Guides_Insert_Input;
}>;


export type AddGuideMutation = { __typename?: 'mutation_root', insert_guides_one?: { __typename?: 'guides', id: any, title?: string | null, description?: string | null, status: string, video_url?: string | null, created_at: any, updated_at: any, guide_file_url?: string | null, created_by_user_id?: string | null, is_public?: boolean | null, workspace_id?: any | null, organization_id?: any | null, handover_id?: any | null } | null };


export const AddGuideDocument = gql`
    mutation addGuide($input: guides_insert_input!) {
  insert_guides_one(object: $input) {
    id
    title
    description
    status
    video_url
    created_at
    updated_at
    guide_file_url
    created_by_user_id
    is_public
    workspace_id
    organization_id
    handover_id
  }
}
    `;
export type AddGuideMutationFn = Apollo.MutationFunction<AddGuideMutation, AddGuideMutationVariables>;

/**
 * __useAddGuideMutation__
 *
 * To run a mutation, you first call `useAddGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGuideMutation, { data, loading, error }] = useAddGuideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGuideMutation(baseOptions?: Apollo.MutationHookOptions<AddGuideMutation, AddGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGuideMutation, AddGuideMutationVariables>(AddGuideDocument, options);
      }
export type AddGuideMutationHookResult = ReturnType<typeof useAddGuideMutation>;
export type AddGuideMutationResult = Apollo.MutationResult<AddGuideMutation>;
export type AddGuideMutationOptions = Apollo.BaseMutationOptions<AddGuideMutation, AddGuideMutationVariables>;